/* Gleva · Direction B · gvb-home.js — small home behaviours (port of final-b2/_src/home.js):
   - gvb-bestsellers: category filter chips ([data-best] [data-filter], cards carry data-cat);
   - gvb-help-choose: need chips are tabs (click + arrow keys) over the answer cards;
   - gvb-kit: tier rows (label.tier > radio) drive the button label, price and sticker; "Add kit to bag" posts the
     tier's items with GVB.cartAdd (the property _gvb_kit = tier name on each line of a multi-product tier).
   - [data-scroll-focus] (gvb-chapter steps rail): tabindex=0 only while the list scrolls sideways (phones).
   Product adds in the chapter, feature panel and help-me-choose cards go through Impact's product form (gvb.js). */
import { G } from 'gvb';

const $ = (s, r) => (r || document).querySelector(s);
const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

function bootBest(sec) {
  if (sec._gvbBest) return;
  sec._gvbBest = true;
  const btns = $$('[data-filter]', sec), rail = $('.best-rail', sec);
  btns.forEach((b) => b.addEventListener('click', () => {
    const f = b.dataset.filter;
    btns.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    $$('.pcard', rail).forEach((c) => c.classList.toggle('is-out', f !== 'all' && c.dataset.cat !== f));
    if (rail && rail.scrollLeft) rail.scrollTo({ left: 0, behavior: G.reduce ? 'auto' : 'smooth' });
    G.updateRails(sec);
  }));
}

function bootHmc(sec) {
  if (sec._gvbHmc) return;
  sec._gvbHmc = true;
  const tabs = $$('[role="tab"]', sec);
  const pick = (t, focus) => {
    tabs.forEach((x) => {
      const on = x === t;
      x.setAttribute('aria-selected', on ? 'true' : 'false');
      x.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(x.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    if (focus) t.focus();
  };
  tabs.forEach((t, k) => {
    t.addEventListener('click', () => pick(t));
    t.addEventListener('keydown', (e) => {
      const n = tabs.length;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); pick(tabs[(k + 1) % n], true); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); pick(tabs[(k - 1 + n) % n], true); }
      if (e.key === 'Home') { e.preventDefault(); pick(tabs[0], true); }
      if (e.key === 'End') { e.preventDefault(); pick(tabs[n - 1], true); }
    });
  });
}

function bootKit(kit) {
  if (kit._gvbKit) return;
  kit._gvbKit = true;
  const rows = $$('.tier', kit), btn = $('[data-kit-add]', kit);
  if (!rows.length || !btn) return;
  const priceEl = $('[data-kit-price]', kit), labelEl = $('[data-kit-label]', kit);
  const sticker = $('[data-kit-sticker]', kit), stickerLbl = $('[data-kit-sticker-label]', kit), status = $('[data-kit-status]', kit);
  let current = $('.tier.is-on', kit) || rows[rows.length - 1];
  const pick = (t) => {
    current = t;
    rows.forEach((x) => { const on = x === t; x.classList.toggle('is-on', on); const i = $('input', x); if (i) i.checked = on; });
    G.setPrice(priceEl, t.dataset.price);
    if (sticker) G.setPrice(sticker, t.dataset.price);
    if (labelEl && t.dataset.cta) labelEl.textContent = t.dataset.cta;
    if (stickerLbl) stickerLbl.textContent = t.dataset.sticker || '';
    const out = t.hasAttribute('data-soldout');
    btn.disabled = out;
    btn.classList.toggle('is-soldout', out);
  };
  rows.forEach((t) => { const i = $('input', t); if (i) i.addEventListener('change', () => pick(t)); });
  pick(current);
  btn.addEventListener('click', async () => {
    if (btn.getAttribute('aria-busy') === 'true' || btn.disabled) return;
    const ids = (current.dataset.items || '').split(',').filter(Boolean);
    if (!ids.length) return;
    const multi = ids.length > 1;
    const items = ids.map((id) => (multi ? { id: Number(id), quantity: 1, properties: { _gvb_kit: current.dataset.name } } : { id: Number(id), quantity: 1 }));
    const img = $('.kit-photo img', kit);
    btn.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';
    try {
      await G.cartAdd(items, { name: current.dataset.name, price: Number(current.dataset.price), thumb: img ? (img.currentSrc || img.src) : '', source: kit });
      G.flashAdded(btn);
    } catch (e) {
      if (status) status.textContent = (e && e.message) || 'Could not add to bag. Please try again.';
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });
}

/* a scrolling list with no focusable content must be focusable itself (WCAG 2.1.1; axe scrollable-region-focusable) */
const scrollFocus = () => $$('[data-scroll-focus]').forEach((el) => {
  if (el.scrollWidth > el.clientWidth + 2) el.setAttribute('tabindex', '0'); else el.removeAttribute('tabindex');
});
let sfT;
window.addEventListener('resize', () => { clearTimeout(sfT); sfT = setTimeout(scrollFocus, 150); });

const init = (scope) => {
  scrollFocus();
  $$('[data-best]', scope).forEach(bootBest);
  $$('[data-hmc]', scope).forEach(bootHmc);
  $$('[data-kit]', scope).forEach(bootKit);
};
init(document);
document.addEventListener('shopify:section:load', (e) => init(e.target));
